export function groupTradeMarkers(open, closed, symbol, intervalMs) {
  const positions = new Map();
  for (const row of open) positions.set(String(row.position_id), { row, closed: false });
  for (const row of closed) positions.set(String(row.position_id), { row, closed: true });
  const groups = new Map();
  for (const { row, closed: isClosed } of positions.values()) {
    const time = new Date(row.position_opened_at || row.created_at).getTime();
    if (row.symbol !== symbol || !Number.isFinite(time) || !['Buy', 'Sell'].includes(row.direction)) continue;
    const key = `${Math.floor(time / intervalMs) * intervalMs}:${row.direction}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push({ id: String(row.position_id), closed: isClosed });
  }
  for (const items of groups.values()) items.sort((a, b) => a.id.localeCompare(b.id));
  return new Map([...groups.entries()].sort(([a], [b]) => a.localeCompare(b)));
}

// Own only these two factories. Updating a position does not append a factory
// for every historical trade (or clear unrelated bullets on the same series).
export function createTradeMarkerOwner() {
  let previousSeries, previousKey;
  let factories = [];
  const clear = () => {
    if (previousSeries && !previousSeries.isDisposed()) {
      factories.forEach(factory => previousSeries.bullets.removeValue(factory));
    }
    factories = [];
    previousSeries = undefined;
    previousKey = undefined;
  };
  return {
    update(series, groups, styleKey, createBullet) {
      const key = JSON.stringify([styleKey, [...groups]]);
      if (previousSeries === series && previousKey === key) return;
      clear();
      if (!series || series.isDisposed()) return;
      previousSeries = series;
      previousKey = key;
      if (!groups.size) return;
      factories = ['Buy', 'Sell'].map(direction => (root, valueSeries, item) => {
        const positions = groups.get(`${item.dataContext.Date}:${direction}`);
        return positions?.length ? createBullet(root, valueSeries, item, positions, direction) : undefined;
      });
      factories.forEach(factory => series.bullets.push(factory));
    },
    dispose: clear,
  };
}
